import { useEffect, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';
import { useT } from '../i18n/index.js';
import { vigilarVersiones } from '../lib/actualizacion.js';
import { Ico } from './Iconos.js';

/**
 * A new version found while the app is open: looked for every quarter of an hour, and when the
 * connection comes back (`lib/actualizacion.ts`).
 *
 * Offered here rather than forced. `registerType: 'prompt'` exists for this: silently swapping the
 * app out from under someone mid-sale would drop what they had on screen. The banner waits until
 * they are between customers and can choose the moment. «Después» puts it off until the next
 * PIN, no longer: past the PIN a new version takes «Actualizar» (`VersionNueva.tsx`).
 */
export function ActualizacionDisponible() {
  const t = useT();
  const [disponible, setDisponible] = useState(false);
  const [actualizar, setActualizar] = useState<(() => void) | null>(null);

  useEffect(() => {
    const update = registerSW({
      onNeedRefresh() {
        setDisponible(true);
      },
    });
    setActualizar(() => () => void update(true));
  }, []);

  useEffect(() => vigilarVersiones(), []);

  if (!disponible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-800 bg-slate-900 p-4">
      <div className="mx-auto flex max-w-2xl items-center gap-4">
        <p className="flex-1 text-sm">{t('actualizar.hayVersion')}</p>
        <button
          type="button"
          className="btn-secundario gap-1.5 px-4 text-sm"
          onClick={() => setDisponible(false)}
        >
          <Ico icono="despues" className="size-4" />
          {t('actualizar.despues')}
        </button>
        <button
          type="button"
          className="btn-primario gap-1.5 px-4 text-sm"
          onClick={() => actualizar?.()}
        >
          <Ico icono="actualizar" className="size-4" />
          {t('actualizar.ahora')}
        </button>
      </div>
    </div>
  );
}
